import { Table, Transfer } from 'antd'
import React from 'react'

const TableTransfer = ({
  leftColumns,
  rightColumns,
  filteredItems = [],
  titles,
  setDataEnable,
  selectedItems,
  setSelectedItems,
  ...restProps
}) => {
  return (
    <Transfer {...restProps}>
      {({
        direction,
        filteredItems,
        onItemSelect,
        onItemSelectAll,
        selectedKeys: listSelectedKeys,
        disabled: listDisabled,
      }) => {
        const columns = direction === 'left' ? leftColumns : rightColumns
        const rowSelection = {
          onChange(selectedRowKeys) {
            onItemSelectAll(selectedRowKeys, 'replace')
          },

          selectedRowKeys: listSelectedKeys,
        }

        return (
          <Table
            rowSelection={rowSelection}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            columns={columns}
            dataSource={filteredItems}
            pagination={false}
            size="small"
            style={{
              pointerEvents: listDisabled ? 'none' : undefined,
            }}
            onRow={({ key, disabled: itemDisabled }) => ({
              onClick: () => {
                if (itemDisabled || listDisabled) {
                  return
                }

                onItemSelect(key, !listSelectedKeys?.includes(key))
              },
            })}
          />
        )
      }}
    </Transfer>
  )
}

export default TableTransfer
